import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormGroup, FormControl, ReactiveFormsModule} from '@angular/forms';
import {Validators} from '@angular/forms';
import {NgForOf, NgIf} from "@angular/common";
import {createPersona} from "../../graphql/graphql.queris";
import {Apollo} from "apollo-angular";
import {ServicesSharedService} from "../services/services-shared.service";

@Component({
  selector: 'app-form-register-user',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgForOf,
    NgIf,
  ],
  templateUrl: './form-register-user.component.html',
  styleUrl: './form-register-user.component.css'
})


export class FormRegisterUserComponent implements OnInit {

  private _personaId: string = '';
  private names: string = '';
  private identificacion: string = '';




  @Input()
  set personaId(value: string) {
    this._personaId = value;
    this.updatePersonaId(value);
  }
  get personaId(): string {
    return this._personaId;
  }
  AddPersonAdmisionForm = new FormGroup({
    firstName: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(20)]),
    secondName: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(20)]),
    firstApellido: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(20)]),
    secondApellido: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(20)]),
    inputEmail: new FormControl('', [Validators.required, Validators.email]),
    fecha: new FormControl('', [Validators.required]),
    inputSexo: new FormControl('', Validators.required),
    inputAddress: new FormControl('', Validators.required),
    idPersona: new FormControl('', Validators.required),
    inputPhone: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(10)]),
  });

  ngOnInit(): void {
    this.AddPersonAdmisionForm.get('idPersona')?.setValue(this.personaId);
  }

  get firstName() {
    return this.AddPersonAdmisionForm.get('firstName');
  }

  get secondName() {
    return this.AddPersonAdmisionForm.get('secondName');
  }

  get firstApellido() {
    return this.AddPersonAdmisionForm.get('firstApellido');
  }

  get secondApellido() {
    return this.AddPersonAdmisionForm.get('secondApellido');
  }

  get inputEmail() {
    return this.AddPersonAdmisionForm.get('inputEmail');
  }

  get fecha() {
    return this.AddPersonAdmisionForm.get('fecha');
  }

  get inputSexo() {
    return this.AddPersonAdmisionForm.get('inputSexo');
  }

  get inputAddress() {
    return this.AddPersonAdmisionForm.get('inputAddress');
  }

  get inputPhone() {
    return this.AddPersonAdmisionForm.get('inputPhone');
  }

  get idPersona() {
    return this.AddPersonAdmisionForm.get('idPersona');
  }

  sexOptions = [
    {name: 'Masculino', value: 'M'},
    {name: 'Femenino', value: 'F'},
  ];







  onSubmit() {
    if (this.AddPersonAdmisionForm.valid) {
      this.addPerson();
    }
  }


  constructor(
    private apollo: Apollo,
    private cdr: ChangeDetectorRef,
    private ServicesShared: ServicesSharedService
  ) {
  }
  private updatePersonaId(value: string): void {
    if (this.AddPersonAdmisionForm) {
      this.AddPersonAdmisionForm.get('idPersona')?.setValue(value);
      this.cdr.detectChanges();
    }
  }



  addPerson() {

    let tipoDocumento: number;

    function tipoDocumentos(documento: any){

      if (documento.length == 10){
        tipoDocumento = 1;
      }else if (documento.length == 13 ){
        tipoDocumento = 2;
      }else if (documento.length >13 && documento.length < 20){
        tipoDocumento = 3;
      }else{
        throw new Error('Documento no valido');
      }
      return tipoDocumento;
    }




    const dataUser = {
      input : {
        cli_direccion: this.AddPersonAdmisionForm.get('inputAddress')?.value,
        cli_no_identificacion: this.AddPersonAdmisionForm.get('idPersona')?.value,
        cli_telefono_principal: this.AddPersonAdmisionForm.get('inputPhone')?.value,
        cod_tipo_identificacion: tipoDocumentos(this.AddPersonAdmisionForm.get('idPersona')?.value),
        pers_email: this.AddPersonAdmisionForm.get('inputEmail')?.value,
        pers_genero_sexo: this.AddPersonAdmisionForm.get('inputSexo')?.value,
        pers_nacimiento_fecha: this.AddPersonAdmisionForm.get('fecha')?.value,
        pers_primer_apellido: this.AddPersonAdmisionForm.get('firstApellido')?.value,
        pers_primer_nombre: this.AddPersonAdmisionForm.get('firstName')?.value,
        // pers_registro_fecha: formatearFechaCompleta(new Date()),
        pers_segundo_apellido: this.AddPersonAdmisionForm.get('secondApellido')?.value,
        pers_segundo_nombre: this.AddPersonAdmisionForm.get('secondName')?.value,
      }

      // cli_nombres_completos: this.AddPersonAdmisionForm.get('firstName')?.value + ' ' + this.AddPersonAdmisionForm.get('secondName')?.value + ' ' + this.AddPersonAdmisionForm.get('firstApellido')?.value + ' ' + this.AddPersonAdmisionForm.get('secondApellido')?.value
    };




    this.apollo.mutate({
      mutation: createPersona,
      variables: dataUser
    }).subscribe((result: any) => {
      this.ServicesShared.validatorFormShow.emit({
        data: result.data.createPersona.cli_no_identificacion
      });
    }, (error) => {
      console.error('Error al crear la persona', error);
    });
  }

}
